/* eslint-disable class-methods-use-this */
import Base from '@studiometa/js-toolkit';
import { isDev } from '../config';
import MaintenanceSlider from '../components/MaintenanceSlider';

/**
 * PageCategory class.
 */
class PageCategory extends Base {
  static config = {
    log: isDev(),
    name: 'PageCategory',
    components: {
      MaintenanceSlider,
    },
  };
}

const pageCategory = new PageCategory(document.documentElement);
pageCategory.$mount();

export default pageCategory;
